import React from "react";
import { Box } from "@catchoftheday/cg-components";
import { useTheme } from "@catchoftheday/theme";
export const ContentWrapper = (props) => {
    const theme = useTheme();
    return (<Box backgroundColor="white">
      <Box mx="auto" px={4} maxWidth={theme.maxWidths.cotdWebsite} {...props}></Box>
    </Box>);
};
